import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import Button, { ButtonVariant } from "./Button";
const ModalConfirmation = ({ message, children, buttonConfirm, buttonConfirmContents, buttonReject, buttonRejectContents, }) => {
    const savedHandler = useRef(null);
    useEffect(() => {
        savedHandler.current = window.addEventListener('keydown', (ev) => {
            if (ev.key === 'Escape') {
                buttonReject();
            }
        });
        // Cleanup
        return () => {
            window.removeEventListener('keydown', savedHandler.current);
        };
    }, []);
    return (_jsx("div", { className: "fixed top-0 left-0 w-screen h-screen z-10 bg-white bg-opacity-75 flex justify-center place-items-center text-base", children: _jsxs("div", { className: "m-8 p-8 border-salmon-600 border-2 bg-white bg-opacity-100 max-w-md", children: [_jsx("span", { className: "font-heavy text-xl", children: message }), children, buttonConfirmContents && (_jsx(Button, { onClick: buttonConfirm, className: "mt-8", variant: ButtonVariant.Salmon, children: buttonConfirmContents })), buttonRejectContents && (_jsx(Button, { onClick: buttonReject, className: "mt-8", variant: ButtonVariant.Outlined, children: buttonRejectContents }))] }) }));
};
export default ModalConfirmation;
